/* Honey Farm theme JS: bee reservation forms + simple helpers */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function show(el, text) { if (!el) return; el.textContent = text; el.classList.add('is-visible'); }
  function hide(el) { if (!el) return; el.classList.remove('is-visible'); }

  // Bee reservation form: adds the deposit product, and if "pay in full" is picked
  // also adds the balance product, then goes to the cart.
  document.querySelectorAll('[data-bee-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var err = form.querySelector('[data-form-error]');
      var variantId = form.querySelector('[name=id]').value;
      var qtyInput = form.querySelector('[name=quantity]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      var choice = form.querySelector('input[name="properties[Remaining balance]"]:checked');
      var balanceId = form.dataset.balanceId;
      var productTitle = form.dataset.productTitle || '';
      var fullValue = form.dataset.fullValue || '';

      if (!choice) { show(err, 'Please choose how you would like to pay the remaining balance.'); return; }
      hide(err);

      var items = [{ id: parseInt(variantId, 10), quantity: qty, properties: { 'Remaining balance': choice.value } }];
      if (balanceId && choice.value === fullValue) {
        items.push({ id: parseInt(balanceId, 10), quantity: qty, properties: { 'Balance for': productTitle } });
      }

      btn.disabled = true;
      var original = btn.innerHTML;
      btn.innerHTML = 'Adding…';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) { throw new Error(res.body.description || res.body.message || 'Could not add to cart.'); }
          window.location.href = root + 'cart';
        })
        .catch(function (ex) {
          show(err, ex.message);
          btn.disabled = false;
          btn.innerHTML = original;
        });
    });
  });

  // Product page: swap main image when a thumbnail is clicked
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = document.querySelector('[data-main-image]');
      if (main) main.src = t.dataset.thumb;
    });
  });

  // Product page: update price and button when the variant changes
  var variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      var price = document.querySelector('[data-variant-price]');
      var btn = document.querySelector('[data-add-button]');
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
      if (btn) {
        var available = opt.dataset.available === 'true';
        btn.disabled = !available;
        btn.textContent = available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
      }
    });
  }
})();
